// Client-side row/draft IDs via Web Crypto (not secrets). Same URL-safe alphabet as nanoid defaults.
const URL_ALPHABET =
  "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

const makeIdFactory =
  (alphabet: string, size: number): (() => string) =>
  () => {
    const bytes = new Uint8Array(size);
    crypto.getRandomValues(bytes);
    let id = "";
    for (let i = 0; i < size; i++) {
      id += alphabet[bytes[i]! % alphabet.length]!;
    }
    return id;
  };

export const customAlphabet = (
  alphabet: string,
  size: number
): (() => string) => makeIdFactory(alphabet, size);

const defaultNanoid21 = makeIdFactory(URL_ALPHABET, 21);

export const nanoid = (size = 21): string =>
  size === 21 ? defaultNanoid21() : makeIdFactory(URL_ALPHABET, size)();

export const simpleId21 = customAlphabet(
  "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
  21
);

export const simpleId = customAlphabet(
  "1234567890abcdefghijklmnopqrstuvwxyz",
  6
);

// 'O' omitted to avoid confusion with '0' when team IDs are read aloud.
export const simpleTeamId = customAlphabet(
  "1234567890ABCDEFGHIJKLMNPQRSTUVWXYZ",
  8
);
